export default "__VITE_ASSET__DdxkxCev__"